module.exports = __webpack_public_path__ + "media/images/edools-logo-new-grey-5a2b4eef10d3d557648223f874a4f830.png";